import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { FundsFeatureConfig } from '../../../types/features/FundsFeatureConfig';
import { funds as base } from './base';
import { funds as AT } from './AT';
import { funds as CZ } from './CZ';
import { funds as HR } from './HR';
import { funds as HU } from './HU';
import { funds as RO } from './RO';
import { funds as RS } from './RS';
import { funds as SK } from './SK';

export const fundsConfig: InsuranceIndex<FundsFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    RS,
    SK,
};
